export const customStyles = {
  control: (base, state) => {
    const isMobile = window.innerWidth < 640; // Example: Tailwind's sm breakpoint

    return {
      ...base,
      borderColor: state.isFocused ? "black" : "#ccc",
      boxShadow: state.isFocused ? "0 0 0 1px black" : "none",
      "&:hover": {
        borderColor: "black",
      },
      minHeight: isMobile ? "33px" : "40px",
      fontSize: isMobile ? "13px" : "14px",
      borderRadius: "5px",
      paddingLeft: isMobile ? "2px" : "3px",
      // zIndex: 2,
    };
  },
  // placeholder: (provided) => ({
  //   ...provided,
  //   color: "#000000", // Your placeholder color
  // }),
  // singleValue: (base) => ({
  //   ...base,
  //   color: "#000000", // Selected value color
  // }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: "#000000",
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: "#333",
    fontSize: window.innerWidth < 640 ? "12px" : "14px",
  }),
  multiValueRemove: (base) => ({
    ...base,
    color: "#666",
    ":hover": {
      backgroundColor: "#000000",
      color: "black",
    },
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isFocused ? "#000000" : "#ffffff",
    color: state.isFocused ? "#ffffff" : "#000000",
    cursor: "pointer",
    fontSize: window.innerWidth < 640 ? "13px" : "14px",
    zIndex: 9999,
  }),
  menu: (base) => ({
    ...base,
    zIndex: 9999,
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  clearIndicator: (base) => ({
    ...base,
    padding: 0, // Remove padding
    cursor: "pointer", // Make sure the clear button is clickable
    // "&:hover": {
    //   backgroundColor: "#e0e0e0", // Optional: Add a hover effect for the clear button
    // },
  }),
  dropdownIndicator: (base, state) => {
    const isMobile = window.innerWidth < 640;

    return {
      ...base,
      color: state.isFocused ? "#000000" : "#6b7280",
      padding: isMobile ? "4px" : "6px",
      transition: "all 0.2s ease",

      "&:hover": {
        color: "#000000",
      },

      svg: {
        width: isMobile ? 16 : 18,
        height: isMobile ? 16 : 18,
        transform: state.selectProps.menuIsOpen
          ? "rotate(180deg)"
          : "rotate(0deg)",
        transition: "transform 0.2s ease",
      },
    };
  },
};

export const formatRole = (role) => {
  if (!role) return "";
  return role
    .toLowerCase()
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export function formatViewDate(dateString) {
  if (!dateString) return "";

  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // months are 0-indexed
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
}

export function formatViewTime(timeString) {
  if (!timeString) return "";

  const date = new Date(`1970-01-01T${timeString}`);

  const hours = String(date.getHours() % 12 || 12).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const period = date.getHours() >= 12 ? "PM" : "AM";

  return `${hours}:${minutes} ${period}`;
}



export function formatCapitalText(status) {
  if (!status) return "";
  return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
}

export function formatStatus(status) {
  if (!status) return "";

  // Replace underscores with spaces, split into words
  return status
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}

export function formatWithTimeDate(dateString) {
  if (!dateString) return "";

  const date = new Date(dateString);

  const day = date.toLocaleString("en-GB", { day: "2-digit" });
  const month = date.toLocaleString("en-GB", { month: "2-digit" });
  const year = date.getFullYear();
  const time = date.toLocaleString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  return `${day}/${month}/${year} ${time}`;
}

export function formatText(status) {
  if (!status) return "";

  // Replace underscores with spaces, split into words
  return status
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}

export const filterActiveItems = (data) => {
  if (!Array.isArray(data)) return [];

  return data.filter(
    (item) => String(item?.status || "").toUpperCase() === "ACTIVE",
  );
};
export const sanitizeInput = (value = "") =>
  value.replace(/[^a-zA-Z0-9 @&*()_–—,.|:"'-]/g, "");

export const capitalizeLocation = (value = "") => {
  return value
    .trim()
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase());
};